(function() {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function disableMobileFacebookFrame(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('[data-fb-page-wrapper]').forEach(function(wrapper) {
      if (wrapper.dataset.bgtcgMobileFallback === 'true') return;
      wrapper.dataset.bgtcgMobileFallback = 'true';
      wrapper.innerHTML = '<div class="fb-plugin-fallback">Facebook 動態未能載入。<br><a href="https://www.facebook.com/battleground.hk" target="_blank" rel="noopener noreferrer">開啟 Battleground Facebook 專頁</a></div>';
    });
  }

  var currentStock = 'all';
  var currentRarity = 'all';

  function setActiveButton(selector, activeValue, attrName) {
    document.querySelectorAll(selector).forEach(function(button) {
      button.classList.toggle('active', button.getAttribute(attrName) === activeValue);
    });
  }

  function restoreVisibleCards() {
    document.querySelectorAll('#ProductGridContainer .grid__item:not(.rarity-hidden):not(.stock-hidden)').forEach(function(item) {
      item.classList.remove('scroll-trigger--offscreen');
      item.style.removeProperty('opacity');
      item.style.removeProperty('transform');
      item.style.removeProperty('visibility');
    });
  }

  function applyTopFilters() {
    var flatItems = document.querySelectorAll('#ProductGridContainer .bgtcg-mobile-flat-grid .grid__item[data-rarity]');
    if (!flatItems.length) return;

    flatItems.forEach(function(item) {
      var rarity = item.getAttribute('data-rarity');
      var available = item.getAttribute('data-available');
      var rarityMatch = currentRarity === 'all' || currentRarity === rarity;
      var stockMatch = currentStock === 'all' ||
        (currentStock === 'in' && available === 'true') ||
        (currentStock === 'out' && available === 'false');

      item.classList.toggle('rarity-hidden', !rarityMatch);
      item.classList.toggle('stock-hidden', !stockMatch);
    });
    restoreVisibleCards();
  }

  function handleTopFilterClick(event) {
    if (!isMobile()) return;

    var stockButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-stock]');
    var rarityButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-rarity]');
    var resetButton = event.target.closest && event.target.closest('#collectionTopFilter .filter-reset');
    if (!stockButton && !rarityButton && !resetButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (stockButton && typeof window.filterStock === 'function') {
      window.filterStock(stockButton.getAttribute('data-stock') || 'all', stockButton);
      return;
    }
    if (rarityButton && typeof window.filterRarity === 'function') {
      window.filterRarity(rarityButton.getAttribute('data-rarity') || 'all', rarityButton);
      return;
    }
    if (resetButton && typeof window.resetFilters === 'function') {
      window.resetFilters();
      return;
    }

    if (stockButton) currentStock = stockButton.getAttribute('data-stock') || 'all';
    if (rarityButton) currentRarity = rarityButton.getAttribute('data-rarity') || 'all';
    if (resetButton) {
      currentStock = 'all';
      currentRarity = 'all';
    }

    setActiveButton('#collectionTopFilter button[data-stock]', currentStock, 'data-stock');
    setActiveButton('#collectionTopFilter button[data-rarity]', currentRarity, 'data-rarity');
    applyTopFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      disableMobileFacebookFrame();
    });
  } else {
    disableMobileFacebookFrame();
  }

  document.addEventListener('click', handleTopFilterClick, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) disableMobileFacebookFrame(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.__bgtcgMobileSafeEntry = {
    redirectsDisabled: true,
    linkRewritesDisabled: true
  };
})();
